import React, {useContext, useState} from 'react'
import AuthenticationAPI from "../../../services/AuthenticationAPI";
import AuthenticationContext from "../../../services/AuthenticationContext";
import Links from "../../../Route";
import Link from "../../../components/Link";

const SignIn = ({history}) => {

    const redirectUserToHome = () => {
        history.replace(Links.Home.link);
    }

    const alertMessage = (message) => {
        return <div className="alert alert-danger">{message}</div>;
    }

    const {isAuthenticated, setIsAuthenticated} = useContext(AuthenticationContext);

    let message = "";
    if(AuthenticationAPI.getCurrentAuth() && AuthenticationAPI.auth.isSessionExpired){
        message = alertMessage(AuthenticationAPI.getCurrentAuth().message);
    }
    const [alertElement, setAlertElement] = useState(message);

    const [user, setUser] = useState({
        email: "",
        password: "",
    });

    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setUser({...user, [name]: value});
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            const response = await AuthenticationAPI.login(user);
            if(response !== true){
                const message = AuthenticationAPI.response && AuthenticationAPI.response.message ? AuthenticationAPI.response.message : "Connexion impossible.";
                setAlertElement(alertMessage(message));
                return;
            }
            setIsAuthenticated(true);
            redirectUserToHome();
        }
        catch (error){console.log(error)}
    }

    return (
        <>
            <div className="inner-head bg-animate">
                <div className="container">
                    <div className="row text-center">
                        <div className="col-md-8 col-md-offset-2">
                            <h3>{Links.SignIn.label}</h3>
                        </div>
                    </div>
                </div>
            </div>

            <div className="clearfix"></div>
            <div className="inner-page">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2"></div>
                        <div className="col-md-8">
                            {alertElement}
                            <form onSubmit={handleSubmit}>
                                <div className="clearfix"></div>
                                <ul className="listForm">
                                    <li className="full-list">
                                        <label>Email :</label>
                                        <input className="form-control input-email input-lg" type="text" name="email" onChange={handleChange} />
                                    </li>
                                    <li className="full-list">
                                        <label>Mot de passe :</label>
                                        <input className="form-control input-name input-lg" type="password" name="password" onChange={handleChange} />
                                    </li>
                                    <li className="full-list">
                                        <Link data={{
                                            type: "NavLink",
                                            href: Links.PasswordForgotten.link,
                                            label: Links.PasswordForgotten.label,
                                        }} />
                                    </li>
                                    <li className="full-list last-list">
                                        <input type="submit" value="Je me connecte" className="btn btn-primary btn-lg btn-block" name="submit"/>
                                    </li>
                                </ul>
                            </form>
                        </div>
                        <div className="col-md-2"></div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default SignIn;